"use strict";

exports.__esModule = true;
exports["default"] = chain;

function chain(obj) {
  return {
    tap: function tap(interceptor) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      interceptor.apply(undefined, [obj].concat(args));
      return this;
    },
    thru: function thru(interceptor) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      obj = interceptor.apply(undefined, [obj].concat(args));
      return this;
    },
    value: function value() {
      return obj;
    }
  };
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ersinfotech/chain/lib/index.js
 ** module id = 1037
 ** module chunks = 0
 **/